module.exports = __webpack_public_path__ + "static/grafika10@2x-61e9d814ed0ada5aee79e6bef412f76c.png";